import React from "react";
import { ErrorMessage, useField } from "formik";

export type RangeInputProps = {
  min?: string;
  max?: string;
  step?: string;
  disabled?: boolean;
  id?: string;
  name: string;
  label?: string;
  className?: string;
};

export const RangeInput: React.FC<RangeInputProps> = ({
  min,
  max,
  step,
  disabled,
  id,
  name,
  label,
  className,
  ...props
}) => {
  const [, { value }, { setValue }] = useField(name);

  return (
    <>
      <input
        className={[className].filter(c => !!c).join(" ")}
        type="range"
        min={min || 0}
        max={max || 0}
        value={value || 0}
        id={name}
        step={step ? step : 1}
        data-testid={`${id || name}`}
        aria-label={label}
        onChange={e => setValue(e.target.value)}
        disabled={disabled}
        {...props}
      />
      <ErrorMessage name={name} />
    </>
  );
};
